export const companySearchTabs = {
  COMPANY: "company",
  PRODUCT: "product",
};

export const searchTypeCustomStyles = {
  control: (base) => ({
    ...base,
    height: 30,
    width: 125,
    backgroundColor: "#fff",
    fontSize: "14px",
    fontWeight: 500,
    border: "none",
    boxShadow: "none",
  }),
  menu: (base) => ({
    ...base,
    fontSize: "14px",
    fontWeight: 500,
    padding: "8px",
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    height: 30,
    padding: "0px 8px 0px 0px",
    justifyContent: "center !important",
    alignItems: "center !important",
  }),
  valueContainer: (styles) => ({
    ...styles,
    justifyContent: "start !important",
    alignItems: "center !important",
  }),
  option: (base, { isDisabled, isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isDisabled ? null : isSelected ? "rgba(111, 8, 241, 0.1)" : isFocused ? "" : null,
    color: isDisabled ? null : isSelected ? "#1a1722" : isFocused ? "#1a1722" : null,
    cursor: "pointer !important",
    margin: "4px 0",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "rgba(111, 8, 241, 0.1)",
    },
  }),
};

export const datasetTypes = {
  DIRECT: "direct",
  MIRROR: "mirror",
};

export const sortOptionsCompany = [
  { label: "Match Score", value: "nameMatchPercentage" },
  { label: "Imports in last 12 months", value: "import_value" },
  { label: "Exports in last 12 months", value: "export_value" },
];

export const sortOptionsProduct = [
  { label: "Number of Shipments", value: "date" },
  { label: "Value (USD)", value: "shipment_value" },
  { label: "Weight (Kg)", value: "weight" },
];

export const initialMetrics = {
  TotalTradeValue: { from: "", to: "" },
  NumberofShipments: { from: "", to: "" },
  TotalWeight: { from: "", to: "" },
};

const plansMapping = {
  ENTERPRISE: "enterprise",
  ADVANCED: "advanced",
  PRO: "pro",
  BASIC: "starter",
};

const dateRangeLabels = [
  { label: "Year to Date", accessToPlans: [plansMapping.ENTERPRISE, plansMapping.ADVANCED, plansMapping.PRO, plansMapping.BASIC] },
  { label: "Last 1 Year", accessToPlans: [plansMapping.ENTERPRISE, plansMapping.ADVANCED, plansMapping.PRO, plansMapping.BASIC] },
  { label: "Last 2 Years", accessToPlans: [plansMapping.ENTERPRISE, plansMapping.ADVANCED] },
  { label: "Last 3 Years", accessToPlans: [plansMapping.ENTERPRISE] },
  { label: "Last 5 Years", accessToPlans: [plansMapping.ENTERPRISE] },
];

const getDateRanges = () => {
  const today = new Date();

  return dateRangeLabels.map(({ label, accessToPlans }) => {
    const startDate = new Date(today);

    switch (label) {
      case "Year to Date":
        startDate.setMonth(0, 1);
        break;
      case "Last 1 Year":
        startDate.setFullYear(today.getFullYear() - 1);
        break;
      case "Last 2 Years":
        startDate.setFullYear(today.getFullYear() - 2);
        break;
      case "Last 3 Years":
        startDate.setFullYear(today.getFullYear() - 3);
        break;
      case "Last 5 Years":
        startDate.setFullYear(today.getFullYear() - 5);
        break;
      default:
        break;
    }

    return {
      label,
      startDate: startDate.toISOString().split("T")[0],
      endDate: today.toISOString().split("T")[0],
      accessToPlans,
    };
  });
};

export const dateRangeOptions = getDateRanges();

export const getDefaultDateRange = (userPlan) => {
  switch (userPlan) {
    case plansMapping.ENTERPRISE:
      return dateRangeOptions[4];
    case plansMapping.ADVANCED:
      return dateRangeOptions[2];
    case plansMapping.PRO:
      return dateRangeOptions[1];
    case plansMapping.BASIC:
      return dateRangeOptions[1];
    default:
      return dateRangeOptions[1];
  }
};

export const metricRangeLabels = [
  { label: "Total Trade Value (USD)", key: "TotalTradeValue" },
  { label: "Number of Shipments", key: "NumberofShipments" },
  { label: "Total Weight (Kg)", key: "TotalWeight" },
];

export const listedCompanyFilter = [
  { label: "Include Listed Companies", key: "include" },
  { label: "Exclude Listed Companies", key: "exclude" },
];
